import { useEffect, useReducer } from 'react';
import AnalyticsPageView from './AnalyticsPageView';
import { fetchDashboard, fetchPayments, fetchSubscriptions, fetchRevenue } from './analytics.api';

interface AnalyticsState {
  loading: boolean;
  error: string | null;
  dashboard: any | null;
  payments: any | null;
  subscriptions: any | null;
  revenue: any | null;
}

type AnalyticsAction = 
  | { type: 'SET_LOADING'; payload: boolean }
  | { type: 'SET_ERROR'; payload: string | null }
  | { type: 'SET_ANALYTICS_DATA'; payload: { dashboard: any; payments: any; subscriptions: any; revenue: any } }
  | { type: 'RESET_STATE' };

const analyticsReducer=(state:AnalyticsState,action:AnalyticsAction):AnalyticsState=>{
    switch(action.type){
        case'SET_LOADING':return{...state,loading:action.payload};
        case'SET_ERROR':return{...state,error:action.payload,loading:false};
        case'SET_ANALYTICS_DATA':return{...state,...action.payload,error:null,loading:false};
        case'RESET_STATE':return{loading:true,error:null,dashboard:null,payments:null,subscriptions:null,revenue:null};
        default:return state;
    }
};

const AnalyticsPage=()=>{
    const[state,dispatch]=useReducer(analyticsReducer,{loading:true,error:null,dashboard:null,payments:null,subscriptions:null,revenue:null});
    useEffect(()=>{
        let mounted=true;
        (async()=>{
            try{
                const[d,p,s,r]=await Promise.all([fetchDashboard(),fetchPayments(),fetchSubscriptions(),fetchRevenue()]);
                if(!mounted)return;
                dispatch({type:'SET_ANALYTICS_DATA',payload:{dashboard:d,payments:p,subscriptions:s,revenue:r}});
            }catch(e:any){
                if(!mounted)return;
                dispatch({type:'SET_ERROR',payload:e?.message||'Failed to load analytics'});
            }finally{
                if(mounted)dispatch({type:'SET_LOADING',payload:false});
            }
        })();
        return()=>{mounted=false;};
    },[]);
    const envKey=import.meta.env.VITE_QreditCharge_API_KEY as string|undefined;
    const lsKey=typeof window!=='undefined'?window.localStorage?.getItem('QreditCharge_API_KEY')||undefined:undefined;
    const apiKeyMissing=!envKey&&!lsKey;
    return(<AnalyticsPageView loading={state.loading}error={state.error}dashboard={state.dashboard}payments={state.payments}subscriptions={state.subscriptions}revenue={state.revenue}apiKeyMissing={apiKeyMissing}/>);
};

export default AnalyticsPage;
